import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import { API } from '../config/api';

export default function MicrosoftCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const msToken = params.get('ms_token');
        const isNew = params.get('is_new') === 'true';
        const error = params.get('error');

        if (error) {
          toast.error(`Microsoft login failed: ${error}`);
          navigate('/login');
          return;
        }

        if (!msToken) {
          navigate('/login');
          return;
        }

        // Process Microsoft session token
        const res = await fetch(`${API}/auth/microsoft/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ms_token: msToken })
        });

        if (!res.ok) {
          throw new Error('Failed to process Microsoft login');
        }

        const data = await res.json();

        // Use loginWithToken to set auth state
        if (data.access_token && data.user) {
          loginWithToken(data.user, data.access_token);
        }

        // Clear params
        window.history.replaceState(null, '', window.location.pathname);

        toast.success('Welcome to DMV Soundstage!');

        if (isNew || data.is_new_user) {
          navigate('/onboarding', { replace: true });
        } else {
          navigate('/home', { replace: true });
        }
      } catch (error) {
        console.error('Microsoft callback error:', error);
        toast.error('Microsoft login failed. Please try again.');
        navigate('/login');
      }
    };

    processCallback();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary" />
    </div>
  );
}
